import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { logoutRequest } from 'redux/User/actions';

const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(logoutRequest()),
});

class SessionTimeoutWarning extends Component {
  handleExtendSession = () => {
    const { onExtendSession } = this.props;
    onExtendSession();
  };

  handleLogout = () => {
    const { onLogout, logoutUser } = this.props;

    // Clear authentication cookies
    document.cookie = 'user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'role=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    // Call logout actions
    if (onLogout) {
      onLogout();
    }
    logoutUser();
  };

  render() {
    const { open, remainingMinutes } = this.props;

    return (
      <Dialog open={open} disableBackdropClick disableEscapeKeyDown maxWidth="sm" fullWidth aria-labelledby="session-timeout-dialog-title">
        <DialogTitle id="session-timeout-dialog-title">Session Timeout Warning</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Your session will expire in <strong>{remainingMinutes} minutes</strong> due to inactivity.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            For security reasons, inactive sessions are automatically logged out after 20 minutes. Click &quot;Continue Session&quot; to extend your
            session or &quot;Logout&quot; to sign out now.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleLogout} color="secondary" variant="outlined">
            Logout
          </Button>
          <Button onClick={this.handleExtendSession} color="primary" variant="contained" autoFocus>
            Continue Session
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default connect(null, mapDispatchToProps)(SessionTimeoutWarning);
